import Illustration from './Illustration.js'
import './Illustration.scss'
export default Illustration
